export enum MilestoneCode {
  PUP = "PUP",
  DEW = "DEW",
  DOC = "DOC",
  FIW = "FIW",
  ARR = "ARR"
}
